import { Card, Divider, message, Spin, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import DateRangeSelect from "../../../components/DateRangeSelect";

function UsersStats() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    moment("01-01-2000").startOf("days"),
    moment().endOf("days"),
  ]);

  const getStats = async (dates) => {
    setLoading(true);
    let startDate = moment(dates[0]).toString();
    let endDate = moment(dates[1]).toString();
    const res = await apiRequest({
      path:
        apiPaths.stats + `/users?start_date=${startDate}&end_date=${endDate}`,
    });
    setLoading(false);
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setStats(res);
  };

  useEffect(() => {
    getStats(selectedRange);
  }, [selectedRange]);

  const COLORS = [
    "#FFBB28",
    "#f01ff6",
    "#FF0000",
    "#ee550a",
    "#55320a",
    "#FFaa0a",
    "#B7c8a2",
    "#FF8042",
    "#001256",
  ];

  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    value,
    ...props
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <>
        <text {...props}>{value + " users"}</text>;
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      </>
    );
  };

  const data = stats.campuses || [];

  return (
    <div>
      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 15,
        }}
      >
        <div>
          <div style={{ fontSize: 20 }}>Users Registartion Stats</div>
          <div style={{ color: "#b7b7b7" }}>
            Note: Below stats is for the selected date range
          </div>
        </div>
        <div style={{ marginRight: 10 }}>
          <DateRangeSelect
            selectedRange={selectedRange}
            onSelectedRangeChanged={setSelectedRange}
          />
        </div>
      </div>
      <div style={{ marginBottom: 25, minHeight: 300 }}>
        {loading ? (
          <div>
            <Spin /> Loading stats...
          </div>
        ) : (
          <div>
            <div
              className="stats-container"
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-evenly",
              }}
            >
              <div id="table">
                <Table
                  columns={[
                    {
                      title: "Campus",
                      dataIndex: "campus_name",
                    },
                    {
                      title: "Users",
                      dataIndex: "user_count",
                    },
                  ]}
                  size="small"
                  dataSource={data}
                  pagination={false}
                />
              </div>
              <div id="chart">
                <Card style={{ width: "100%" }}>
                  <div
                    style={{
                      width: "100%",
                      height: 300,
                      position: "relative",
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={400} height={400}>
                        <Pie
                          data={data}
                          cx="50%"
                          cy="50%"
                          // labelLine={false}
                          label={renderCustomizedLabel}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey={"user_count"}
                        >
                          {data.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                    }}
                  >
                    {data.map((item, idx) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                        key={idx}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            marginRight: 5,
                            backgroundColor: COLORS[idx],
                          }}
                        />
                        <div>{item.campus_name}</div>
                      </div>
                    ))}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UsersStats;
